import * as React from 'react';
import { inputDialogDriverFactory } from './InputDialog.driver';
import { InputDialog } from '.';
import {
  TPAComponentsWrapper,
  createRendererWithUniDriver,
} from '../../test/utils';

describe('InputDialog', () => {
  const render = createRendererWithUniDriver(inputDialogDriverFactory);

  it('should render', async () => {
    const { driver } = render(<InputDialog />);
    expect(await driver.exists()).toBe(true);
  });

  it('should use mobile design', async () => {
    const { driver } = render(
      TPAComponentsWrapper({ mobile: true })(
        <InputDialog data-hook="input-dialog" />,
      ),
      'input-dialog',
    );
    expect(await driver.isMobile()).toBe(true);
  });

  it('expect dialog to be open', async () => {
    const { driver } = render(<InputDialog isOpen />);
    expect(await driver.isDialogOpen()).toBe(true);
  });

  it('expect dialog to be closed', async () => {
    const { driver } = render(<InputDialog isOpen={false} />);
    expect(await driver.isDialogOpen()).toBe(false);
  });

  it('should render children', async () => {
    const { driver } = render(
      <InputDialog isOpen>
        <div data-hook="dialog-children">Dialog children</div>
      </InputDialog>,
    );
    expect(await driver.childExists('[data-hook="dialog-children"]')).toBe(
      true,
    );
  });

  it('expect onClick to be called after clicking on the close button', async () => {
    const onCloseButtonClick = jest.fn();
    const { driver } = render(
      <InputDialog isOpen onClose={onCloseButtonClick} />,
    );

    await driver.clickOnCloseButton();
    expect(onCloseButtonClick).toHaveBeenCalledTimes(1);
  });

  it('should call onClick handlers for primary button', async () => {
    const onPrimaryButtonClick = jest.fn();
    const { driver } = render(
      <InputDialog
        isOpen
        primaryButton={{
          text: 'Primary Button',
          onClick: onPrimaryButtonClick,
        }}
      />,
    );
    await driver.clickPrimaryButton();
    expect(onPrimaryButtonClick).toHaveBeenCalledTimes(1);
  });

  it('should call onClick handlers for secondary button', async () => {
    const onSecondaryButtonClick = jest.fn();
    const { driver } = render(
      <InputDialog
        isOpen
        secondaryButton={{
          text: 'Secondary Button',
          onClick: onSecondaryButtonClick,
        }}
      />,
    );
    await driver.clickSecondaryButton();
    expect(onSecondaryButtonClick).toHaveBeenCalledTimes(1);
  });

  it('should disable primary button if needed', async () => {
    const { driver } = render(
      <InputDialog
        isOpen
        primaryButton={{
          text: 'Primary Button',
          disabled: true,
          onClick: jest.fn(),
        }}
      />,
    );
    expect(await driver.isPrimaryButtonDisabled()).toEqual(true);
  });

  it('should disable secondary button if needed', async () => {
    const { driver } = render(
      <InputDialog
        isOpen
        secondaryButton={{
          text: 'Primary Button',
          disabled: true,
          onClick: jest.fn(),
        }}
      />,
    );
    expect(await driver.isSecondaryButtonDisabled()).toEqual(true);
  });
});
